import { Link } from "react-router-dom";
import {
  UNREADABLE_LAB_REPORT_LABEL,
  type LabOrderQuarantinedReport,
} from "@care-by-ella/contracts";
import {
  orderQuarantineReasonText,
  quarantineReportHref,
} from "@/lib/labportalen";

// TES-1179 — on a lab order on the Blodprov tab: a LabPortalen answer named
// this order but was quarantined, so the order would otherwise say "Inväntar
// svar". Says that it arrived, why it could not be read in, when, and links
// to the report on "Provsvar utan koppling", where the doctor attaches or
// dismisses it. Both roles that see this tab (doctor, admin) can open that
// screen; only the doctor gets its buttons.
//
// Swedish strings are PROPOSED copy.

function fmt(iso: string): string {
  return new Date(iso).toLocaleString("sv-SE", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Europe/Stockholm",
  });
}

export function LabOrderQuarantinedReports({
  reports,
}: {
  reports: readonly LabOrderQuarantinedReport[] | undefined;
}) {
  if (!reports || reports.length === 0) return null;
  return (
    <ul className="mt-xs flex flex-col gap-xs">
      {reports.map((r) => (
        <li
          key={r.quarantineId}
          data-testid="lab-order-quarantined-report"
          className="rounded-sm border border-warning/30 bg-warning/5 p-sm text-xs"
        >
          <p className="font-semibold text-warning">
            {UNREADABLE_LAB_REPORT_LABEL}
          </p>
          <p className="text-textPrimary">
            Orsak: {orderQuarantineReasonText(r.reason)}
          </p>
          <p className="text-textSecondary">
            {r.reportTime
              ? `Svarstid enligt labbet: ${fmt(r.reportTime)}`
              : `Mottaget: ${fmt(r.receivedAt)}`}
          </p>
          <Link
            to={quarantineReportHref(r.quarantineId)}
            className="text-brand underline"
          >
            Öppna svaret i Provsvar utan koppling
          </Link>
        </li>
      ))}
    </ul>
  );
}
